import React, { MouseEvent, useCallback, useState } from 'react';
import { Card, CardActionArea, CardContent, Typography } from '@mui/material';
import { Link } from 'react-router';

import { LumberListPrototype } from '@paragon/contract-library';
import { hasMaterialsEditPermission } from '@paragon/login-tools';
import { getDefaultLumberListGuid } from '@paragon/material-lists';

import { setDefaultLumberListGuid } from '../../../actions/defaultMaterialSelectionActions';
import {
  archiveLumberList,
  duplicateLumberListPrototype,
  renameLumberList,
  restoreLumberList,
} from '../../../actions/lumberListPrototypeActions';
import { countLumbersInLumberList } from '../../../util';
import { useAppSelector } from '../../hooks';
import { ListMenu } from '../ListMenu';
import { PossiblyArchivedListName } from '../PossiblyArchivedListName';
import { cardSx, defaultListIconSx, flexRowCenteredItemsSx } from './common/card-styles';
import { DefaultListIcon } from './common/DefaultListIcon';

export function LumberListCard(props: { value: LumberListPrototype }) {
  const defaultLumberListGuid = useAppSelector(getDefaultLumberListGuid);
  const hasEditPermission = useAppSelector(hasMaterialsEditPermission);

  const [menuPosition, setMenuPosition] = useState<null | { x: number; y: number }>(null);

  const onContextMenuRequested = useCallback(
    (event: MouseEvent) => {
      event.preventDefault();
      setMenuPosition({ x: event.clientX, y: event.clientY });
    },
    [setMenuPosition],
  );

  return (
    <Card elevation={0} sx={cardSx}>
      <CardActionArea component={Link} to={`/lumberLists/${props.value.guid}`} onContextMenu={onContextMenuRequested}>
        <CardContent>
          <Typography variant="h6" sx={flexRowCenteredItemsSx} gutterBottom>
            <PossiblyArchivedListName name={props.value.name} isArchived={props.value.isArchived} />

            <DefaultListIcon
              type="lumber"
              visible={props.value.guid === defaultLumberListGuid}
              sx={defaultListIconSx}
            />
          </Typography>
          <Typography variant="body2">
            {props.value.lumberSets.length} lumber sets; {countLumbersInLumberList(props.value)} total materials
          </Typography>
        </CardContent>
      </CardActionArea>

      {hasEditPermission && (
        <ListMenu
          noun="lumber"
          list={props.value}
          anchor={menuPosition}
          onClose={() => setMenuPosition(null)}
          setDefaultListGuid={setDefaultLumberListGuid}
          archiveList={archiveLumberList}
          restoreList={restoreLumberList}
          duplicateList={duplicateLumberListPrototype}
          renameList={renameLumberList}
        />
      )}
    </Card>
  );
}
